$(document).on('turbolinks:load', function() {

  // listen to the scanner event
  document.addEventListener("keypress", function(e) {
    if (e.target.tagName !== "INPUT") {
      var input = document.querySelector("#manualField");
      input.focus();
      input.value = e.key;
      e.preventDefault();
    }
  });
  
  // focus on manualField on load
  $('#manualField').trigger('focus');

  // listen to closing the modal
  $('#scanResult, #warehouseScanResult').on('hidden.bs.modal', function (e) {
    $('#manualField').trigger('focus');
  });

  // listen to item type selection
  $('input[type="radio"]').on('click change', function(e) {
    $('#manualField').trigger('focus');
  });

  // listen to institution selection
  $('#item_institution_id, #institution_id').on('change', function(e) {
    e.preventDefault();
    $('#manualField').trigger('focus');
  });

});
